<template>
  <div>
    <template v-if="!isInWechat">
      <div div class="wrap">
        <Header />
        <MainAction :openRulePopup="openRulePopup" :namespace="namespace" />
        <BenefitVisitor
          v-for="item in cardList"
          :key="item.id"
          :floorValue="item"
          @showBenefitPopup="handleShowBenefitPopup"
        />
        <OpenRulePopup :value.sync="showRulePopup" />
        <BenefitPopup
          :value.sync="showBenefitPopup"
          :benefitData="benefitPopupData"
        />
        <div
          class="login-fixed"
          @click="handleLogin"
          :class="{ 'is-scrolling': isScrolling }"
          v-if="!isLogin || !isMember"
        />
        <div class="service-wrap" @click="handleService">
          <svg-icon icon-class="bj-service-hz" class="icon" />客服中心
        </div>
      </div>
    </template>
    <template v-else
      ><div class="wechat">请用支付宝扫描二维码后打开</div></template
    >
  </div>
</template>


<script>
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  onBeforeUnmount,
  watch,
  onUnmounted,
} from "@vue/composition-api";
import Vue from "vue";
import qs from "qs";

import LoginDialog from "@/components/loginDialog";
import { getIndexCategory, getIndexClassList } from "@/apis/product";
import { useStore, useRouter, useRoute } from "@/components/use/base";
import { queryMemberCardInfo } from "@/apis/product";
import { DOMAIN_NAME } from "@/config";

import MainAction from "./components/MainAction.vue";
import Header from "./components/Header.vue";
import OpenRulePopup from "./components/OpenRulePopup.vue";
import BenefitVisitor from "./components/BenefitVisitor.vue";
import BenefitPopup from "./components/BenefitPopup.vue";

const vm = Vue.prototype;

export default defineComponent({
  components: {
    Header,
    MainAction,
    OpenRulePopup,
    BenefitVisitor,
    BenefitPopup,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    const namespace = computed(() => store.state.namespace);
    const isMember = computed(() => store.state.isMember);
    const isLogin = computed(() => !!store.state.token);
    const isAlipay = computed(() => store.state.isAlipay);
    const isInWechat = computed(() => store.state.isWebchat);

    const showRulePopup = ref(false);
    const showBenefitPopup = ref(false);
    const cardList = ref([]);
    const benefitPopupData = ref({});
    const isScrolling = ref(false);
    const authCode = ref("");

    let ticking = false;
    let stopTimer = null;

    onMounted(() => {
      window.addEventListener("scroll", onScroll, { passive: true });
      document.addEventListener("click", handleClick, true);
      getCardConfig();
      handleAlipayAuth();
    });

    const handleAlipayAuth = () => {
      const { auth_code, channel_source } = route.query;
      if (auth_code) {
        authCode.value = auth_code;
        return;
      }
      if (isAlipay.value && !auth_code) {
        router.replace(
          `/alipayAuth?namespace=${
            namespace.value
          }&redirect_uri=${encodeURIComponent(
            `${DOMAIN_NAME}saveMoneyCard?namespace=${
              namespace.value
            }&channel_source=${channel_source || "default"}`
          )}`
        );
      }
    };

    watch(
      isMember,
      (newVal) => {
        if (newVal)
          router.replace(`/index?debug=1&${qs.stringify(route.query)}`);
      },
      {
        immediate: true,
      }
    );

    const handleClick = (event) => {
      if (!isAlipay.value) {
        handleAlipay();
        event.preventDefault();
        event.stopPropagation();
        return;
      }
    };

    const handleAlipay = () => {
      const { channel_source } = route.query;
      const url = `${DOMAIN_NAME}saveMoneyCard?namespace=${
        namespace.value
      }&channel_source=${channel_source || "default"}`;
      const sceme = `alipays://platformapi/startapp?appId=20000067&url=${encodeURIComponent(
        url
      )}`;
      window.location.href = sceme;
    };

    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(() => {
          isScrolling.value = true;
          ticking = false;
        });
      }
      if (stopTimer) clearTimeout(stopTimer);
      stopTimer = setTimeout(() => {
        isScrolling.value = false;
      }, 1000);
    };

    onBeforeUnmount(() => {
      window.removeEventListener("scroll", onScroll);
      if (stopTimer) clearTimeout(stopTimer);
    });

    onUnmounted(() => {
      document.removeEventListener("click", handleClick, true);
    });

    const handleShowBenefitPopup = (item) => {
      benefitPopupData.value = item;
      showBenefitPopup.value = true;
    };

    const getCardConfig = async () => {
      const { data: categoriesData } = await getIndexCategory({
        namespace: "xssqk1",
        opened_page: "member",
        source: "default",
        access_code: authCode.value,
      });

      const { data: productData } = await getIndexClassList({
        title: categoriesData.map((v) => v.name).join(","),
        opened_page: "member",
        namespace: "xssqk1",
      });

      cardList.value = categoriesData
        .filter((v) => v.display_code !== "SaveMoneyHeader")
        .map((v) => ({
          ...v,
          productInfo: productData[v.name] || [],
        }));
    };

    const openRulePopup = () => {
      showRulePopup.value = true;
    };

    const beforeLogin = async ({ phoneNumber }) => {
      const { data } = await queryMemberCardInfo({
        phone_number: phoneNumber,
      });
      const cardList = data.card_list || [];
      const namespace_name = cardList.filter((v) => v.is_active)?.[0]
        ?.namespace_name;
      if (namespace_name) {
        store.commit("changeState", {
          namespace: namespace_name,
        });
      }
    };

    const handleLogin = async () => {
      await LoginDialog.show({
        title: "登录",
        subtitle: "若未注册，将自动免费注册",
        className: "__save-money-card-login",
        showCheck: false,
        beforeLogin,
      });
      if (!isMember.value) {
        vm.$toast("您还不是会员，请开通会员后使用。");
      }
    };

    const handleService = () => {
      router.push("/service");
    };

    return {
      showRulePopup,
      showBenefitPopup,
      cardList,
      benefitPopupData,
      isScrolling,
      namespace,
      isMember,
      isLogin,
      isInWechat,
      handleAlipay,
      openRulePopup,
      handleLogin,
      handleShowBenefitPopup,
      handleService,
    };
  },
});
</script>

<style lang="less" scoped>
.wechat {
  margin: 0 auto;
  line-height: 100vh;
  text-align: center;
  background: #f5f5f5;

  font-weight: 500;
  font-size: 14px;
  color: #333333;
}

.wrap {
  min-height: 100vh;
  background: url("https://common-h5-dev.xiangshuheika.com/static/upload/2025081895af9c5f18a69.png")
    no-repeat;
  background-size: 100% !important;
  padding: 12px;
  box-sizing: border-box;

  .login-fixed {
    position: fixed;
    top: 60%;
    right: 0;
    width: 98px;
    height: 44px;
    border-radius: 100px 0px 0px 100px;
    background: url("https://common-h5-dev.xiangshuheika.com/static/upload/202508187f8c10999e0fd.png")
      no-repeat;
    background-size: 100% !important;
    transform: translateX(0);
    transition: transform 220ms ease, opacity 220ms ease;
    will-change: transform, opacity;

    &.is-scrolling {
      transform: translateX(60%);
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .floating {
    transition: none;
  }
}

.service-wrap {
  margin: 0 auto;
  margin-top: 32px;
  width: 343px;
  height: 32px;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: 400;
  font-size: 15px;
  color: #333333;

  .icon {
    font-size: 20px;
    margin-right: 9px;
  }
}
</style>

<style lang="less">
.__save-money-card-login {
  background: linear-gradient(180deg, #ffecd5 0%, #ffffff 30%) !important;
  box-sizing: border-box;

  .login-desc {
    font-weight: 400;
    font-size: 14px;
    color: #a1a3af;
    line-height: 20px;
    text-align: center;
    margin-top: 7px;
  }
}
</style>
